import { useEffect, useMemo } from 'react'
import style from "../../../sass/components/popups/create-shipment-popup.module.scss";
import { useTranslation } from 'react-i18next'
import { senderCities } from '../../../data/static-data';

const SenderTownInput = ({state, setState, enabled, senderCityCode }) => {
    const {t} = useTranslation()
    const handleChange = (e) => {
        if(!e.target.value) {
            setState("")
            return
        }
        setState(+e.target.value)
    }

    const city = useMemo(() => {
        let city = senderCities.find(city => {
            return city.value === senderCityCode
        })
        return city
    }, [senderCityCode])

    useEffect(() => {
        if(city) {
            let containsTown = city.towns.find(town => {
                return +town.value === +state
            })

            if(!containsTown)
                setState(city.towns[0].value)
        }
        else
            setState("")
    }, [city, setState, state])

    return (
        <>
            <span className='col-span-8 xs:col-span-4 text-left'>
                {t("shipment.shipment_data.additional_data.sender_town.name")}
            </span>
            <select
                className={`${style.select} col-span-10 xs:col-span-8 font-normal`}
                id="sender-region"
                value={state["sender-region"]}
                onInput={handleChange}
                disabled={!enabled}
            >
                <option value="" disabled selected hidden></option>
                {city?.towns?.map((option, index) => (
                    <option
                        selected={+state === +option.value}
                        key={index}
                        value={+option.value}
                    >
                        {option.text}
                    </option>
                ))}
            </select>
        </>
  )
}

export default SenderTownInput